import {Currency} from '../enums/Currency';
import {TimePeriod} from './TimePeriod';
import {PriceCapacity} from '../enums/PriceCapacity';
import {BookingOption} from '../enums/BookingOption';

export class BookingPrice {
  id: number;
  officeId: number;
  roomId: number;
  bookingOption: BookingOption;
  currency: Currency;
  amount: number;
  capacity: PriceCapacity;
  price: number;
  timePeriod: TimePeriod;
  timePeriodId: number;

  public constructor(init?: Partial<BookingPrice>) {
    Object.assign(this, init);
  }
}
